/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Admin_Discount_Code_Form_Discount_PercentageInputs */

const en_admin_discount_code_form_discount_percentage = /** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% off`)
};

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const de_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const es_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const fr_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const it_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const pt_br2_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const pl_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const hu_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_PercentageInputs) => LocalizedString} */
const ro_admin_discount_code_form_discount_percentage = en_admin_discount_code_form_discount_percentage;

/**
* | output |
* | --- |
* | "{value}% off" |
*
* @param {Admin_Discount_Code_Form_Discount_PercentageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_code_form_discount_percentage = /** @type {((inputs: Admin_Discount_Code_Form_Discount_PercentageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Code_Form_Discount_PercentageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "de") return de_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "es") return es_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "fr") return fr_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "it") return it_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "pl") return pl_admin_discount_code_form_discount_percentage(inputs)
	if (locale === "hu") return hu_admin_discount_code_form_discount_percentage(inputs)
	return ro_admin_discount_code_form_discount_percentage(inputs)
});
export { admin_discount_code_form_discount_percentage as "admin.discount_code_form.discount_percentage" }